<template><site-shell>
 <section class="error-page bs-foundation" aria-labelledby="error-title">
  <h1 id="error-title" tabindex="-1">{{ error.title }}</h1>
  <div role="alert" class="auth-notice">
   <p v-if="error.status === 404">We could not find this page. Check the address or return to your dashboard.</p>
   <p v-else-if="error.status === 500">We could not complete your request. Please try again later.</p>
   <p v-else-if="error.status === 403">You do not have permission to view this page.</p>
   <ul v-else><li v-for="(message, index) in error.messages" :key="index">{{ message }}</li></ul>
  </div>
  <nav aria-label="Error recovery" class="bs:flex bs:flex-wrap bs:items-center bs:gap-lg"><a class="bs-button" :href="error.recovery">{{ error.status === 400 ? 'Try uploading again' : 'Dashboard' }}</a> <a class="bs-button" href="/">Home</a> <a class="bs-button bs-button--text" href="/login">Log in</a></nav>
 </section>
</site-shell></template>
<script>
import errorPage from './errorPage';
import SiteShell from './SiteShell.vue';
export default {
 components: { SiteShell },
 data() {
  const node = document.getElementById('application-error');
  let payload = null;
  try { payload = node ? JSON.parse(node.textContent) : null; } catch (_) { /* Missing payload uses the missing-page experience. */ }
  return { error: errorPage(payload) };
 },
 mounted() { document.title = this.error.title + ' | BrewStatus'; this.$el.querySelector('h1').focus(); }
};
</script>
<style scoped>
.error-page { width: calc(100% - 2rem); max-width: 700px; margin: 0 auto; }
.error-page h1 { margin: 0 0 1rem; font-size: 2rem; line-height: 1.2857; }
.error-page p { margin: 0; }
.error-page li { overflow-wrap: anywhere; }
#app main .error-page a.bs-button:not(.bs-button--text) { color: var(--bs-color-ink-body); text-decoration: none; }
</style>
